import type React from "react";

import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

import {useEditActions} from "../hooks/useEditActions";

const DeleteSelectionButton: React.FC = () => {
  const {handleDelete} = useEditActions();

  return (
    <>
      <CustomButton
        onClick={handleDelete}
        aria-label="Delete selection"
        className="p-2 rounded-full"
      >
        <FontAwesomeIcon
          icon={faTrash}
          size="xl"
          className="text-white p-2 -m-2 rounded-full pl-2.5 pr-2.5 bg-gradient-to-br from-red-600 via-red-500 to-black"
        />
      </CustomButton>
    </>
  );
};

export default DeleteSelectionButton;
